import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { showCookieConsent, waitForCookiebot } from "../../../utils/cookiebot";

export default class CookieDeclaration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      declarationLoaded: false,
      error: null,
    };
  }

  componentDidMount() {
    this.loadCookieDeclaration();
  }

  loadCookieDeclaration = () => {
    if (!process.env.REACT_APP_CBID) {
      this.setState({
        error:
          "Cookie declaration cannot be loaded: REACT_APP_CBID not configured.",
      });
      return;
    }

    // Check if declaration script is already loaded
    const existingScript = document.querySelector(
      `script[src*="${process.env.REACT_APP_CBID}/cd.js"]`,
    );
    if (existingScript) {
      this.setState({ declarationLoaded: true });
      return;
    }

    // Wait for Cookiebot to be available, then load the declaration script
    waitForCookiebot(() => {
      try {
        const script = document.createElement("script");
        script.id = "CookieDeclaration";
        script.src = `https://consent.cookiebot.com/${process.env.REACT_APP_CBID}/cd.js`;
        script.type = "text/javascript";
        script.async = true;

        // Add error handling for script loading
        script.onerror = () => {
          this.setState({
            error: "Failed to load cookie declaration script.",
          });
        };

        script.onload = () => {
          this.setState({
            declarationLoaded: true,
            error: null,
          });
        };

        const declarationContainer = document.querySelector("#cb_declaration");
        if (declarationContainer) {
          // Clear any existing content
          declarationContainer.innerHTML = "";
          // Append script to head instead of container for better compatibility
          document.head.appendChild(script);
        } else {
          this.setState({
            error: "Cookie declaration container not found.",
          });
        }
      } catch (error) {
        this.setState({
          error: `Error loading cookie declaration: ${error.message}`,
        });
      }
    });
  };

  render() {
    const { declarationLoaded, error } = this.state;

    return (
      <div style={{ margin: "50px" }}>
        <Helmet>
          <title>Cookie Policy - Dansk Standard</title>
        </Helmet>

        <h1>Cookie Policy</h1>
        <p>
          This page provides detailed information about the cookies used on our
          website. You can manage your cookie preferences at any time using the
          cookie settings button or by clicking the button below.
        </p>

        {process.env.REACT_APP_CBID && (
          <div style={{ marginBottom: "20px" }}>
            <button
              onClick={showCookieConsent}
              style={{
                backgroundColor: "#0066cc",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#0052a3";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#0066cc";
              }}
            >
              Manage Cookie Preferences
            </button>
          </div>
        )}

        {error && (
          <div
            style={{
              color: "red",
              marginBottom: "20px",
              padding: "10px",
              border: "1px solid red",
              borderRadius: "5px",
              backgroundColor: "#ffebee",
            }}
          >
            {error}
          </div>
        )}

        {!process.env.REACT_APP_CBID && (
          <div
            style={{
              color: "#666",
              fontStyle: "italic",
              marginBottom: "20px",
            }}
          >
            Cookie declaration is not available because Cookiebot is not
            configured.
          </div>
        )}

        <div id="cb_declaration">
          {!declarationLoaded && !error && process.env.REACT_APP_CBID && (
            <div style={{ color: "#666", fontStyle: "italic" }}>
              Loading cookie declaration...
            </div>
          )}
        </div>
      </div>
    );
  }
}
